export class UserPreference {
    UserPreferenceId: number;
    UserId : string;
    CustomerId:string;
    FacilityId: string;
    CustomerName : string;
    FacilityName : string;
}


// WEBPACK FOOTER //
// ./src/app/models/UserPreference.ts